import { trackUsage } from '../../../deferred/analytics/NavUsageTrackers';
export const trackUpgradeButtonClick = () => {
  trackUsage('Interaction', {
    class: 'interaction',
    action: 'viewed upgrade point',
    eventKeyName: 'upgradesInteraction',
    upgradeKey: 'global-nav-bar',
    source: 'global-nav-bar'
  }, {
    isStandalone: true,
    namespace: 'Upgrades'
  });
};